export default class UIComponent {
  constructor(interfaces) {
    if(interfaces) {
      this.theme = interfaces.vhallplayer.theme === 'light' ? true : false;
    }
  }
  /**
   * 追加节点
   * @param {string} parentId 节点的class或id
   * @param {dom} child 要追加的节点
   */
  appendChild(className, child) {
    const parent = document.querySelector(`${className}`);
    parent.appendChild(child)
  }

  /**
   * @description 为 Html 对象插入子元素
   * @param {BOM} HtmlElement
   * @param {BOM} child
   */
  insertElement(HtmlElement, child) {
    HtmlElement.appendChild(child);
  }

  appendFirstChild(className, child) {
    const parent = document.querySelector(`${className}`);
    parent.insertBefore(child, parent.firstChild);
  }
}